// Components==============
import { faBell } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TopNav } from '@pimbutton/tast-components-lib';
import logoutUser from 'actions/authentication/logout';
import Avatar from 'components/UI/Avatar/Avatar';
import UnreadCount from 'components/UI/Communication/UnreadCount/UnreadCount';
import { AnimatePresence } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useRootModal } from 'hooks/useRootModal';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { LayoutContext } from '../Layout';
import Messages from './components/Messages/Messages';
import Settings from './components/Settings/Settings';
import './TopNav.module.scss';
// =========================

export default function TopNavComponent() {
  const { setHamburgerIsOpen } = useContext(LayoutContext);
  const [displayMessages, setDisplayMessages] = useState(false);

  const user = useRedux((state) => state.authentication?.user);
  const dispatch = useReduxAction();
  const { push } = useHistory();

  function handleLogout() {
    dispatch(logoutUser()).then(() => push('/inloggen'));
  }

  const { setModal } = useRootModal();

  const messageRef = useRef<HTMLDivElement>(null);

  const notifications =
    useRedux((state) => {
      const entities = state.notification?.entities.allIds.map(
        (id) => state.notification?.entities.byId[id]
      );

      return entities
        ?.map((e) => {
          if (!e?.target) return undefined;

          const projectId = e.project_id
            ? e.project_id
            : e.target
            ? 'project_id' in e.target
              ? e.target.project_id
              : e.target.id
            : 0;

          const themeId =
            state.project?.entities.byId?.[projectId]?.theme_id || 0;

          const theme = state.theme?.entities.byId?.[themeId];

          if (!theme) return undefined;

          return e;
        })
        .filter((exists) => exists);
    })?.length || 0;

  return (
    <>
      <TopNav
        handleLogout={handleLogout}
        handleProfileClick={() => setModal(<Settings />)}
        image={<Avatar />}
        setHamburgerNavOpen={() => setHamburgerIsOpen(true)}
        items={
          <>
            <div
              onClick={() => setDisplayMessages((prev) => !prev)}
              className="icon left"
              ref={messageRef}
            >
              <FontAwesomeIcon icon={faBell} />
              {!!notifications && (
                <div styleName="count">
                  <UnreadCount count={notifications} small />
                </div>
              )}
            </div>
          </>
        }
        userInfo={
          <>
            <p styleName="name">{`${user?.first_name} ${user?.last_name}`}</p>
            <p styleName="role">
              {user?.roles[0].name === 'Docent'
                ? 'Groown-up'
                : user?.roles[0].name === 'super-admin'
                ? 'God of growth'
                : user?.roles[0].name === 'Leerling Portfolio'
                ? 'Student'
                : user?.roles[0].name}
            </p>
          </>
        }
      />
      <AnimatePresence>
        {displayMessages && (
          <Messages
            handleClose={() => setDisplayMessages(false)}
            messageRef={messageRef}
          />
        )}
      </AnimatePresence>
    </>
  );
}
